import axios from "axios";

const baseURL = axios.create({
  baseURL: "https://select-proposal-api-b4e057f5ce9b.herokuapp.com",
  // baseURL: "http://localhost:3000",
});

// Always read the latest token from localStorage on every request
// (instead of capturing it once at module load time, which caused
//  stale-token 401 errors after long browsing sessions)
baseURL.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default baseURL;
// select-proposal-api-b4e057f5ce9b.herokuapp.com
